import { subscribe, unsubscribe } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';

import { useMediator } from '../useMediator';

export const useCommonPageSubscribers = () => {
  let __listSubscribers = [];

  const [getMediator, setMediator] = useMediator();

  const setSub = () => {
    __listSubscribers.push(
      subscribe(way.DRIVE_MAP_STATIC_POINT_SELECTED, getMediator().notify)
    );
    // __listSubscribers.push( subscribe( way.DRIVE_LIST_POINT_MOUSE_OVER, getMediator().notify ) );
    __listSubscribers.push(
      subscribe(way.DRIVE_MAP_STATIC_POINT_MOUSEENTER, getMediator().notify)
    );
    __listSubscribers.push(
      subscribe(way.DRIVE_BUILDER_PART_ACTION, getMediator().notify)
    );
    // __listSubscribers.push( subscribe( way.DRIVE_MAP_POINT_DRAGEND, getMediator().notify ) );
    __listSubscribers.push(
      subscribe(way.BUILDER_MAP_REMOVE_PART, getMediator().notify)
    );
    __listSubscribers.push(
      subscribe(way.SAVE_FIRST_PART_MULTIDAY, getMediator().notify)
    );
    __listSubscribers.push(
      subscribe(way.SAVE_MULTI_DAY_COPY_TO_CREATE, getMediator().notify)
    );
    __listSubscribers.push(
      subscribe(way.CORRECT_ALL_WRONG_ROUTES_ON_ALL_PAGES, getMediator().notify)
    );
    // __listSubscribers.push( subscribe( way.DRIVE_BUILDER_PART_DEVIDE_BY_POINT, getMediator().notify ) );
  };

  const destroySub = () => {
    __listSubscribers.forEach((token) => {
      unsubscribe(token);
    });
    __listSubscribers = [];
  };

  return [{ sub: { set: setSub, destroy: destroySub } }, setMediator];
};
